const updateTenantsSuperadmin = {
  toastr: 'Updated tenant',
  toastr1: ' has been updated successfully',
  toastrError: 'Tenant already registered',
  toastrError1: 'Enter another name'
};

export default updateTenantsSuperadmin;
